export enum YesNoEmpty {
    YES = 1,
    NO = 0,
    EMPTY = -1
}

export const YesNoEmptyOptions = [
    { value: YesNoEmpty.YES, label: "Yes" },
    { value: YesNoEmpty.NO, label: "No" },
    { value: YesNoEmpty.EMPTY, label: " - Unknown - " }
];

export const BooleanToYesNoEmpty = (val: boolean | null | undefined): YesNoEmpty => {
    if (val === true) {
        return YesNoEmpty.YES;
    }
    if (val === false) {
        return YesNoEmpty.NO;
    }
    return YesNoEmpty.EMPTY;
};

export const YesNoEmptyToBoolean = (val: YesNoEmpty): boolean | null => {
    const valParsed = parseInt("" + val, 10);
    if (valParsed === YesNoEmpty.EMPTY) {
        return null;
    }
    return valParsed === YesNoEmpty.YES;
};



// WEBPACK FOOTER //
// ./src/common/Methods/YesNoEmpty.ts